/* eslint-disable react/prop-types */
import { Component } from "react";
import { Alert, Badge, Button, Card, Col, Form, Modal, Row, Spinner, Table } from "react-bootstrap";
import AsyncSelect from "react-select/async";
import Swal from "sweetalert2";

import examesLinhaCuidadoService from "../../api/exames/examesLinhaCuidadoService";
import { formataDataExibicao, formataDataHoraExibicao } from "../../common/utils";

class ExamesLinhaCuidadoAtendimento extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            salvando: false,
            enviandoDocumento: false,
            erro: "",
            resultados: [],
            examesParametrizados: [],
            showModal: false,
            formulario: this.getFormularioInicial(),
            showModalExame: false,
            formExame: { nome: "", codigo: "" },
            salvandoExame: false,
            showModalDocumento: false,
            formDocumento: { resultado_id: null, arquivo: null },
        };
    }

    componentDidMount() {
        this.carregar();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.atendimentoId !== this.props.atendimentoId) {
            this.carregar();
        }
    }

    getFormularioInicial = () => ({
        id: null,
        exame_id: "",
        exame_label: "",
        resultado: "",
        data_realizacao: "",
    });

    getMensagemErro = (error, fallback) => {
        const data = error?.response?.data;

        if (typeof data === "string" && data.trim()) {
            return data;
        }

        if (data && typeof data === "object") {
            const primeiraChave = Object.keys(data)[0];
            const primeiroValor = data[primeiraChave];

            if (Array.isArray(primeiroValor) && primeiroValor.length > 0) {
                return primeiroValor[0];
            }

            if (typeof primeiroValor === "string" && primeiroValor.trim()) {
                return primeiroValor;
            }
        }

        return fallback;
    };

    carregar = async () => {
        const { atendimentoId } = this.props;

        if (!atendimentoId) {
            this.setState({ loading: false, resultados: [], examesParametrizados: [] });
            return;
        }

        this.setState({ loading: true, erro: "" });

        try {
            const response = await examesLinhaCuidadoService.listarResultados(atendimentoId);
            const data = response.data || {};

            this.setState({
                loading: false,
                resultados: Array.isArray(data.resultados) ? data.resultados : [],
                examesParametrizados: Array.isArray(data.exames_parametrizados) ? data.exames_parametrizados : [],
            });
        } catch (error) {
            console.error("Erro ao carregar exames da Linha de Cuidado:", error);
            this.setState({
                loading: false,
                erro: this.getMensagemErro(error, "Não foi possível carregar os exames do paciente."),
            });
        }
    };

    carregarExames = async (inputValue) => {
        try {
            const response = await examesLinhaCuidadoService.listarCatalogo(inputValue);
            const lista = Array.isArray(response.data) ? response.data : [];

            return lista.map((exame) => ({
                value: exame.id,
                label: exame.codigo ? `${exame.nome} (${exame.codigo})` : exame.nome,
            }));
        } catch (error) {
            console.error("Erro ao carregar catálogo de exames:", error);
            return [];
        }
    };

    abrirModalNovo = () => this.setState({ showModal: true, formulario: this.getFormularioInicial() });

    abrirModalEdicao = (registro) => {
        this.setState({
            showModal: true,
            formulario: {
                id: registro.id,
                exame_id: registro.exame_id,
                exame_label: registro.dados_exame?.nome || "",
                resultado: registro.resultado || "",
                data_realizacao: registro.data_realizacao || "",
            },
        });
    };

    fecharModal = () => this.setState({ showModal: false, formulario: this.getFormularioInicial() });

    onChangeFormulario = (event) => {
        const { name, value } = event.target;
        this.setState((estado) => ({ formulario: { ...estado.formulario, [name]: value } }));
    };

    salvar = async () => {
        const { atendimentoId } = this.props;
        const { formulario } = this.state;

        if (!formulario.exame_id) {
            Swal.fire("Atenção", "Selecione o exame.", "warning");
            return;
        }

        if (!formulario.resultado.trim()) {
            Swal.fire("Atenção", "Informe o resultado do exame.", "warning");
            return;
        }

        if (!formulario.data_realizacao) {
            Swal.fire("Atenção", "Informe a data de realização.", "warning");
            return;
        }

        const payload = {
            atendimento_id: atendimentoId,
            exame_id: formulario.exame_id,
            resultado: formulario.resultado.trim(),
            data_realizacao: formulario.data_realizacao,
        };

        this.setState({ salvando: true });

        try {
            if (formulario.id) {
                await examesLinhaCuidadoService.atualizarResultado(formulario.id, payload);
            } else {
                await examesLinhaCuidadoService.registrarResultado(payload);
            }

            this.setState({ salvando: false, showModal: false, formulario: this.getFormularioInicial() });
            await this.carregar();
            Swal.fire("Sucesso", formulario.id ? "Resultado atualizado com sucesso." : "Resultado registrado com sucesso.", "success");
        } catch (error) {
            console.error("Erro ao salvar resultado de exame:", error);
            this.setState({ salvando: false });
            Swal.fire("Erro", this.getMensagemErro(error, "Não foi possível salvar o resultado."), "error");
        }
    };

    excluir = async (registro) => {
        const confirmacao = await Swal.fire({
            title: "Confirmar exclusão?",
            text: `Deseja remover o resultado de ${registro.dados_exame?.nome || "este exame"}?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sim, remover",
            cancelButtonText: "Cancelar",
        });

        if (!confirmacao.isConfirmed) {
            return;
        }

        try {
            await examesLinhaCuidadoService.removerResultado(registro.id);
            await this.carregar();
            Swal.fire("Sucesso", "Resultado removido com sucesso.", "success");
        } catch (error) {
            console.error("Erro ao remover resultado de exame:", error);
            Swal.fire("Erro", this.getMensagemErro(error, "Não foi possível remover o resultado."), "error");
        }
    };

    abrirModalExame = () => this.setState({ showModalExame: true, formExame: { nome: "", codigo: "" } });

    fecharModalExame = () => this.setState({ showModalExame: false });

    salvarExame = async () => {
        const { formExame } = this.state;

        if (!formExame.nome.trim()) {
            Swal.fire("Atenção", "Informe o nome do exame.", "warning");
            return;
        }

        this.setState({ salvandoExame: true });

        try {
            const resposta = await examesLinhaCuidadoService.cadastrarExame(formExame.nome.trim(), formExame.codigo.trim());
            const novo = resposta.data || {};

            this.setState((estado) => ({
                salvandoExame: false,
                showModalExame: false,
                formulario: {
                    ...estado.formulario,
                    exame_id: novo.id,
                    exame_label: novo.codigo ? `${novo.nome} (${novo.codigo})` : novo.nome,
                },
            }));

            Swal.fire("Sucesso", "Exame cadastrado e selecionado.", "success");
        } catch (error) {
            console.error("Erro ao cadastrar exame:", error);
            this.setState({ salvandoExame: false });
            Swal.fire("Erro", this.getMensagemErro(error, "Não foi possível cadastrar o exame."), "error");
        }
    };

    abrirModalDocumento = (resultadoId) => {
        this.setState({ showModalDocumento: true, formDocumento: { resultado_id: resultadoId, arquivo: null } });
    };

    fecharModalDocumento = () => this.setState({ showModalDocumento: false });

    enviarDocumento = async () => {
        const { formDocumento } = this.state;

        if (!formDocumento.arquivo) {
            Swal.fire("Atenção", "Selecione o arquivo.", "warning");
            return;
        }

        this.setState({ enviandoDocumento: true });

        try {
            await examesLinhaCuidadoService.enviarDocumento(formDocumento.resultado_id, formDocumento.arquivo);
            this.setState({ enviandoDocumento: false, showModalDocumento: false });
            await this.carregar();
            Swal.fire("Sucesso", "Documento anexado com sucesso.", "success");
        } catch (error) {
            console.error("Erro ao anexar documento do exame:", error);
            this.setState({ enviandoDocumento: false });
            Swal.fire("Erro", this.getMensagemErro(error, "Não foi possível anexar o documento."), "error");
        }
    };

    excluirDocumento = async (documento) => {
        const confirmacao = await Swal.fire({
            title: "Confirmar exclusão?",
            text: "Deseja remover este documento?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sim, remover",
            cancelButtonText: "Cancelar",
        });

        if (!confirmacao.isConfirmed) {
            return;
        }

        try {
            await examesLinhaCuidadoService.excluirDocumento(documento.id);
            await this.carregar();
            Swal.fire("Sucesso", "Documento removido com sucesso.", "success");
        } catch (error) {
            console.error("Erro ao remover documento do exame:", error);
            Swal.fire("Erro", this.getMensagemErro(error, "Não foi possível remover o documento."), "error");
        }
    };

    renderDocumentos = (registro) => {
        const { podeEditar } = this.props;
        const documentos = registro.documentos || [];

        if (documentos.length === 0) {
            return <span className="text-muted">-</span>;
        }

        return (
            <ul className="list-unstyled mb-0">
                {documentos.map((documento) => (
                    <li key={documento.id}>
                        {documento.arquivo_url ? (
                            <a href={documento.arquivo_url} target="_blank" rel="noreferrer">
                                {documento.nome_original || "Abrir"}
                            </a>
                        ) : (
                            <span>{documento.nome_original || "-"}</span>
                        )}
                        {documento.data_criacao && (
                            <small className="text-muted"> ({formataDataHoraExibicao(documento.data_criacao)})</small>
                        )}
                        {podeEditar && (
                            <Button variant="link" size="sm" className="text-danger p-1" onClick={() => this.excluirDocumento(documento)}>
                                Excluir
                            </Button>
                        )}
                    </li>
                ))}
            </ul>
        );
    };

    renderParametrizados = () => {
        const { examesParametrizados } = this.state;

        if (examesParametrizados.length === 0) {
            return (
                <Alert variant="light" className="mb-0">
                    Nenhum exame obrigatório parametrizado para esta Linha de Cuidado.
                </Alert>
            );
        }

        return (
            <div>
                {examesParametrizados.map((item) => (
                    <Badge bg="light" text="dark" className="me-2 mb-1 border" key={item.id}>
                        {item.dados_exame?.nome} · {item.periodicidade_display}
                        {item.obrigatorio ? "" : " (opcional)"}
                    </Badge>
                ))}
            </div>
        );
    };

    renderModalResultado = () => {
        const { showModal, formulario, salvando } = this.state;

        return (
            <Modal show={showModal} onHide={this.fecharModal} size="lg" backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>{formulario.id ? "Editar resultado" : "Registrar resultado de exame"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col sm={12} className="mb-3">
                            <div className="d-flex justify-content-between align-items-center">
                                <Form.Label className="mb-0">Exame *</Form.Label>
                                <Button variant="link" size="sm" onClick={this.abrirModalExame}>
                                    Cadastrar novo exame
                                </Button>
                            </div>
                            <AsyncSelect
                                cacheOptions
                                defaultOptions
                                loadOptions={this.carregarExames}
                                value={formulario.exame_id ? { value: formulario.exame_id, label: formulario.exame_label } : null}
                                onChange={(opcao) =>
                                    this.setState((estado) => ({
                                        formulario: { ...estado.formulario, exame_id: opcao?.value || "", exame_label: opcao?.label || "" },
                                    }))
                                }
                                placeholder="Busque pelo nome do exame..."
                                noOptionsMessage={() => "Nenhum exame encontrado"}
                            />
                        </Col>
                        <Col sm={12} className="mb-3">
                            <Form.Label>Resultado *</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                name="resultado"
                                value={formulario.resultado}
                                onChange={this.onChangeFormulario}
                                placeholder="Ex.: 92 mg/dL ou Sem alterações significativas"
                            />
                        </Col>
                        <Col sm={6} className="mb-3">
                            <Form.Label>Data de realização *</Form.Label>
                            <Form.Control
                                type="date"
                                name="data_realizacao"
                                max={new Date().toISOString().slice(0, 10)}
                                value={formulario.data_realizacao}
                                onChange={this.onChangeFormulario}
                            />
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.fecharModal} disabled={salvando}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={this.salvar} disabled={salvando}>
                        {salvando ? "Salvando..." : "Salvar"}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    };

    renderModalExame = () => {
        const { showModalExame, formExame, salvandoExame } = this.state;

        return (
            <Modal show={showModalExame} onHide={this.fecharModalExame} backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>Cadastrar exame</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Label>Nome do exame *</Form.Label>
                    <Form.Control
                        className="mb-3"
                        value={formExame.nome}
                        onChange={(event) =>
                            this.setState((estado) => ({ formExame: { ...estado.formExame, nome: event.target.value } }))
                        }
                    />
                    <Form.Label>Código (opcional)</Form.Label>
                    <Form.Control
                        value={formExame.codigo}
                        onChange={(event) =>
                            this.setState((estado) => ({ formExame: { ...estado.formExame, codigo: event.target.value } }))
                        }
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.fecharModalExame} disabled={salvandoExame}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={this.salvarExame} disabled={salvandoExame}>
                        {salvandoExame ? "Salvando..." : "Cadastrar"}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    };

    renderModalDocumento = () => {
        const { showModalDocumento, enviandoDocumento } = this.state;

        return (
            <Modal show={showModalDocumento} onHide={this.fecharModalDocumento} backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>Anexar documento</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Label>Arquivo *</Form.Label>
                    <Form.Control
                        type="file"
                        onChange={(event) =>
                            this.setState((estado) => ({
                                formDocumento: { ...estado.formDocumento, arquivo: event.target.files[0] },
                            }))
                        }
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.fecharModalDocumento} disabled={enviandoDocumento}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={this.enviarDocumento} disabled={enviandoDocumento}>
                        {enviandoDocumento ? "Enviando..." : "Anexar"}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    };

    render() {
        const { podeEditar } = this.props;
        const { loading, erro, resultados } = this.state;

        if (loading) {
            return (
                <div className="text-center mt-4">
                    <Spinner animation="border" />
                </div>
            );
        }

        if (erro) {
            return (
                <Alert variant="danger" className="mt-4">
                    {erro}
                </Alert>
            );
        }

        return (
            <>
                <Card className="cardDestaque mt-4">
                    <Card.Body>
                        <h6 className="mb-2">Exames obrigatórios da Linha de Cuidado</h6>
                        {this.renderParametrizados()}
                    </Card.Body>
                </Card>

                <Card className="cardDestaque mt-4">
                    <Card.Body>
                        <Row className="align-items-center mb-3">
                            <Col sm={8}>
                                <h5 className="mb-0">Resultados de Exames</h5>
                            </Col>
                            <Col sm={4} className="text-end">
                                {podeEditar && (
                                    <Button variant="outline-primary" size="sm" onClick={this.abrirModalNovo}>
                                        Registrar resultado
                                    </Button>
                                )}
                            </Col>
                        </Row>

                        <Table responsive className="custom-table table-sm align-middle mb-0">
                            <thead>
                                <tr>
                                    <th>Exame</th>
                                    <th>Resultado</th>
                                    <th>Data de realização</th>
                                    <th>Documentos</th>
                                    {podeEditar && <th className="text-end">Ações</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {resultados.length === 0 ? (
                                    <tr>
                                        <td colSpan={podeEditar ? 5 : 4} className="text-center">
                                            Nenhum resultado de exame registrado.
                                        </td>
                                    </tr>
                                ) : (
                                    resultados.map((registro) => (
                                        <tr key={registro.id}>
                                            <td>{registro.dados_exame?.nome || "-"}</td>
                                            <td style={{ whiteSpace: "pre-wrap" }}>{registro.resultado}</td>
                                            <td>{registro.data_realizacao ? formataDataExibicao(registro.data_realizacao) : "-"}</td>
                                            <td>{this.renderDocumentos(registro)}</td>
                                            {podeEditar && (
                                                <td className="text-end">
                                                    <Button variant="outline-secondary" size="sm" className="me-2" onClick={() => this.abrirModalEdicao(registro)}>
                                                        Editar
                                                    </Button>
                                                    <Button variant="outline-primary" size="sm" className="me-2" onClick={() => this.abrirModalDocumento(registro.id)}>
                                                        Anexar
                                                    </Button>
                                                    <Button variant="outline-danger" size="sm" onClick={() => this.excluir(registro)}>
                                                        Remover
                                                    </Button>
                                                </td>
                                            )}
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </Table>
                    </Card.Body>
                </Card>

                {this.renderModalResultado()}
                {this.renderModalExame()}
                {this.renderModalDocumento()}
            </>
        );
    }
}

export default ExamesLinhaCuidadoAtendimento;
